var _g, _g2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "photo-camera_2_",
    "data-name": "photo-camera (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.524,
    height: 22.819,
    viewBox: "0 0 28.524 22.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56114",
    "data-name": "Group 56114",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56113",
    "data-name": "Group 56113",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87699",
    "data-name": "Path 87699",
    d: "M25.113,51.073H22.137l-1.643-2.48A3.415,3.415,0,0,0,17.672,47.1H10.852A3.415,3.415,0,0,0,8.03,48.592l-1.643,2.48H3.41A3.4,3.4,0,0,0,0,54.483v12.03a3.4,3.4,0,0,0,3.41,3.41h21.7a3.4,3.4,0,0,0,3.41-3.41V54.483A3.4,3.4,0,0,0,25.113,51.073ZM14.262,67.133a7.674,7.674,0,1,1,7.689-7.658A7.688,7.688,0,0,1,14.262,67.133ZM24.679,55.878H23.315a1.009,1.009,0,0,1,0-2.015h1.24a1.006,1.006,0,0,1,1.054.961A.982.982,0,0,1,24.679,55.878Z",
    transform: "translate(0 -47.104)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_56116",
    "data-name": "Group 56116",
    transform: "translate(9.983 8.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56115",
    "data-name": "Group 56115",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87700",
    "data-name": "Path 87700",
    d: "M169.143,180.736a4.263,4.263,0,1,0,4.279,4.248A4.287,4.287,0,0,0,169.143,180.736Z",
    transform: "translate(-164.864 -180.736)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.e81441ba4d497407181b1c794092ebe8.svg";
export { ForwardRef as ReactComponent };